import { render, staticRenderFns } from "./use-info.vue?vue&type=template&id=ff84cb8c&"
import script from "./use-info.vue?vue&type=script&lang=js&"
export * from "./use-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports